export const uk = {
    additions: 'Дополнения: {additionsList}'
};
